import { PageLoader } from '@zeiss/lib-components';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from 'src/App';
import 'src/assets/styles/global.css';
import 'src/i18n';

const rootEl = document.getElementById('root') as HTMLElement;

createRoot(rootEl).render(
  <React.StrictMode>
    <React.Suspense fallback={<PageLoader label="Loading" size="xl" />}>
      <App />
    </React.Suspense>
  </React.StrictMode>,
);
